module.exports = __webpack_public_path__ + "static/media/img-logo-l.ed1803ac.png";